import React from 'react';
import { useDialog } from 'core/hooks';
import { useGetCaseData } from 'games/CaseGame/hooks';
import {
  Button,
  Container,
  Content,
  ContentWrapper,
  Header,
  HeaderSpan,
  Name,
  Price,
  SpanCount,
} from './cases-counts.styles';
import { useTranslation } from 'react-i18next';
import { CurrencyText } from '@components/currency';
import { CaseItemDialog } from 'games/CaseGame';
import { formatPercent } from 'core/utils';
import { CustomItemInfo } from 'games/CaseGame/interfaces/cases.interface';

export const CasesCountsDialog = () => {
  const { handleCloseDialog } = useDialog(CaseItemDialog.COUNT_DIALOG);
  const { t } = useTranslation('cases2.0');

  const { data } = useGetCaseData();
  const key = localStorage.getItem('itemName') || '';
  const headerTabs = [
    t('countsDialogHeader.wear'),
    t('countsDialogHeader.price'),
    t('countsDialogHeader.odds'),
  ];

  const items = (data?.itemsForCaseShow?.[key]?.customItemInfo as CustomItemInfo[]) || [];

  return (
    <Container>
      <Header>
        {headerTabs.map(tab => (
          <HeaderSpan key={tab}>{tab}</HeaderSpan>
        ))}
      </Header>
      <ContentWrapper>
        {items.map(({ exterior, count, price }, idx) => (
          <Content key={`${exterior}-${price}-${idx}`}>
            <Name>{exterior}</Name>
            <Price>
              <CurrencyText value={price} />
            </Price>
            <SpanCount>{formatPercent(count, { includePercent: true })}</SpanCount>
          </Content>
        ))}
      </ContentWrapper>
      <Button onClick={handleCloseDialog}>{t('countsDialogHeader.close')}</Button>
    </Container>
  );
};
